module.exports = __webpack_public_path__ + "static/media/check-square.a20fda29.svg";